import { lazy } from "react";
import { RouteConfig } from "../../../types/RouteConfig";

export const invitesRoute: RouteConfig<'with-page'> = {
    name: 'My Invites',
    path: '/training/invites',
    page: lazy(() => import('.')),
    flags: ['member-route'],
    context:'member'
}